import localForage from 'localforage';

localForage.config({
  name: 'Tocompete PWA App',
});

export const offlineData = localForage.createInstance({
  name: 'offlineData',
});
